'use client';
import MyPlusApi from '@/api/main/my-plus';
import MyCatch from '@/components/my/common/item/MyCatch';
import {SoopUiSwiper} from '@/components/ui';
import {SectionHeader} from '@/components/main/common';
import {CATCH_CONTEXT_MENU} from '@/constants/main';
import {useEffect, useState} from 'react';
import {useHiddenStreamer} from '../../common/hooks/useHiddenStreamer';
import '/public/static/css/module/catch_list.scss';
import {decodeFullHtmlEntities} from '@/utils';
import {VOD_TYPES} from '@/constants';
import {getDomParser, getTextFromReactNode} from '@/utils/main/my-plus/section';

export const CatchStoryGroup = ({order}) => {
  const swiperConfig = {
    loop: false,
    spaceBetween: 20,
  };

  const [catchStoryList, setCatchStoryList] = useState([]);
  const [catchStoryTitle, setCatchStoryTitle] = useState('');
  const [catchStoryIdList, setCatchStoryIdList] = useState([]);
  const [userNick, setUserNick] = useState('');
  const {
    hiddenStreamerList,
    handleOnClickHiddenStreamer,
    handleOnClickUndoHiddenStreamer,
  } = useHiddenStreamer('CATCHSTORY', 'myplus');

  const headerText = (
    <>
      {userNick}님의 관심
      <span className='catch'>{catchStoryTitle}</span>
    </>
  );

  useEffect(() => {
    getPreferCatchStoryList();
  }, []);

  const getPreferCatchStoryList = async () => {
    try {
      const response = await MyPlusApi.getPreferCatchStoryList();

      if (response && response.result === 1) {
        setUserNick(response.data.unick);
        setCatchStoryTitle(response.data.title);
        setCatchStoryList(response.data.list);
        setCatchStoryIdList(response.data.list.map((item) => item.storyIdx));
      }
    } catch (error) {
      setCatchStoryList([]);
    }
  };

  const handleOnClickMenu = (e, type, data) => {
    if (type === 'hidden') {
      handleOnClickHiddenStreamer(data);
    }
  };

  const handleUndoBroadcast = (data) => {
    if (hiddenStreamerList.includes(data.broadcastId)) {
      handleOnClickUndoHiddenStreamer(data);
    }
  };

  return (
    <>
      {catchStoryList && catchStoryList.length > 0 && (
        <>
          <SectionHeader title={headerText} />
          <div className='catch_story_area'>
            <SoopUiSwiper
              swiperClass='catch_list catch_story_list'
              swiperTag='ul'
              maxSlidesPerView={10}
              otherMaxSlidesResolution={[
                {max: 1623, slidePerView: 10},
                {max: 1202, slidePerView: 8},
                {max: 1000, slidePerView: 6},
                {max: 751, slidePerView: 5},
                {max: 496, slidePerView: 4},
                {max: 0, slidePerView: 3},
              ]}
              options={swiperConfig}>
              {catchStoryList.map((item, idx) => (
                <li key={idx} className='play_on'>
                  <MyCatch
                    {...{
                      ...item,
                      title: decodeFullHtmlEntities(item.titleName),
                      catchId:
                        item.fileType === VOD_TYPES.CATCH_STORY
                          ? item.storyIdx
                          : item.titleNo,
                      isHorizontal: item.resolutionType === 'horizontal',
                      isAdult:
                        Number(item.grade) === 19 &&
                        Number(item.category) === 30000,
                      thumbnailSrc:
                        item.fileType === VOD_TYPES.CATCH_STORY
                          ? item.resolutionType === 'horizontal'
                            ? item.thumb
                            : item.verticalThumb
                          : item.resolutionType === 'horizontal'
                            ? item.thumbH
                            : item.thumb,
                      userNickname: item.originalUserNick,
                      userId: item.originalUserId,
                      viewCount: item.viewCnt || 0,
                      broadcastDate: item.broadDate,
                      listDataType:
                        item.fileType === VOD_TYPES.CATCH_STORY
                          ? 'catchstory'
                          : item.listDataType,
                      fileType: item.fileType,
                      isStory:
                        item.fileType === VOD_TYPES.CATCH_STORY ? true : false,
                      catchIdList: catchStoryIdList,
                      catchContextMenuList: CATCH_CONTEXT_MENU,
                    }}
                    hiddenStreamerList={hiddenStreamerList}
                    handleUndoBroadcast={handleUndoBroadcast}
                    handleMenuClicked={handleOnClickMenu}
                    isLogSendData={{
                      path3: 'story',
                      sectionIdx: order,
                      sectionTitle: getTextFromReactNode(headerText),
                    }} // 스토리 섹션에서 노출되는 캐치도 유입경로를 story로 보내줘야 함
                  />
                </li>
              ))}
            </SoopUiSwiper>
          </div>
        </>
      )}
    </>
  );
};
